import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Skydda Microsoft 365 med Controla",
  header: "Skydda Microsoft 365 med Controla",
  date: "2026-09-07",
  description:
    "Skydda Microsoft 365 med Controla. Hitta kontobrister, riskfyllda inloggningar och för brett delade filer. Åtgärda med vägledning och automatiserade åtgärder.",
  category: "produkt",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
